/* SNZ-PDP-METER, 12 Oct 2026 (Z): free-UK-delivery progress on product pages.
 *
 * WHY: Clarity (5-11 Oct) showed cushion visitors picking a size and stopping
 * before Add to cart. Most single sets are under the £50 free-delivery line,
 * and the page only said "free over £50". This shows, live, how far THIS set
 * plus whatever is already in the bag is from free delivery, e.g.
 * "£20.10 away from free UK delivery", with the same bar the bag drawer uses.
 *
 * Loaded from sections/snz-free-returns.liquid, UK (GB + GBP) product pages
 * only, never on the bed builder (it has its own meter). Threshold is passed
 * from that section; keep it equal to snippets/snz-drawer-perks.liquid
 * (snz_free_from) and the delivery profile's "Free UK Delivery" rate.
 * Never computes a price of its own: it reads the selected variant's price
 * (Dawn's [data-selected-variant] JSON / variantChange event) and /cart.js.
 * Revert = delete the <script> line in sections/snz-free-returns.liquid.
 */
(function () {
  'use strict';
  if (window.__snzPdpMeter) return;
  window.__snzPdpMeter = true;

  var tag = document.currentScript;
  var FREE = parseInt((tag && tag.getAttribute('data-free-from')) || '5000', 10); /* pence */
  var cart = parseInt((tag && tag.getAttribute('data-cart')) || '0', 10) || 0;   /* pence */
  var variantPrice = null; /* pence */
  var CSS =
    '.snz-pm{margin:1rem 0 0;font-family:Montserrat,var(--font-body-family),sans-serif;color:#1F2421}' +
    '.snz-pm__line{display:flex;align-items:center;gap:.8rem;margin:0;font-size:1.35rem;line-height:1.4;letter-spacing:.02em}' +
    '.snz-pm__line svg{flex:none;width:1.8rem;height:1.8rem;color:#2D5A50}' +
    '.snz-pm__line strong{font-weight:600}' +
    '.snz-pm[data-free] .snz-pm__line{color:#2D5A50}' +
    '.snz-pm__bar{height:4px;margin:.7rem 0 0 2.6rem;background:#E5E0DA;border-radius:2px;overflow:hidden}' +
    '.snz-pm__fill{display:block;height:100%;width:0;background:#2D5A50;border-radius:2px;transition:width .35s ease}' +
    '.snz-pm__note{margin:.4rem 0 0 2.6rem;font-size:1.15rem;line-height:1.4;color:#67736F}' +
    '.snz-pm__note:empty{display:none}' +
    /* 13 Oct 2026 (Z): the meter replaces the old "Taxes included. Free Royal Mail delivery on orders over £X" line. The element stays in the DOM as the meter's anchor. */
    '.product__info-container .product__tax{display:none!important}' +
    '@media (prefers-reduced-motion:reduce){.snz-pm__fill{transition:none}}';
  var TRUCK = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"><path d="M2.5 6.5h11v9.5h-11z"/><path d="M13.5 9.5h4.2l3.3 3.4V16h-7.5"/><circle cx="7" cy="17.3" r="1.7" fill="#fff"/><circle cx="17.3" cy="17.3" r="1.7" fill="#fff"/></svg>';

  function money(p) {
    var s = (Math.round(p) / 100).toFixed(2);
    if (s.slice(-3) === '.00') s = s.slice(0, -3);
    return '£' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function scope() {
    var tax = document.querySelector('.product__info-container .product__tax') || document.querySelector('.product__tax');
    return tax ? { tax: tax, box: tax.closest('.product__info-container') || document } : null;
  }

  function readVariant(box) {
    var el = box.querySelector('variant-selects [data-selected-variant]') || box.querySelector('[data-selected-variant]');
    if (el) {
      try { var v = JSON.parse(el.textContent); if (v && typeof v.price === 'number') return v.price; } catch (e) {}
    }
    var p = box.querySelector('.price .price-item--sale') || box.querySelector('.price .price-item--regular');
    var n = p ? parseFloat(p.textContent.replace(/[^0-9.]/g, '')) : NaN;
    return isNaN(n) ? null : Math.round(n * 100);
  }

  function readQty(box) {
    var q = box.querySelector('input.quantity__input[name="quantity"]') || document.querySelector('product-info input.quantity__input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function mount() {
    var s = scope();
    if (!s) return null;
    var root = s.tax.parentNode.querySelector(':scope > [data-snz-pm]');
    if (!root) {
      root = document.createElement('div');
      root.className = 'snz-pm';
      root.setAttribute('data-snz-pm', '');
      root.innerHTML = '<p class="snz-pm__line" role="status" aria-live="polite">' + TRUCK + '<span data-snz-pm-text></span></p>' +
        '<div class="snz-pm__bar" role="progressbar" aria-label="Progress to free UK delivery" aria-valuemin="0" aria-valuemax="' + (FREE / 100) + '"><span class="snz-pm__fill"></span></div>' +
        '<p class="snz-pm__note" data-snz-pm-note></p>';
      /* After the free-returns line when present, so its own duplicate check
         (tax.nextElementSibling has data-snz-fr) keeps holding. */
      var after = s.tax.nextElementSibling && s.tax.nextElementSibling.hasAttribute('data-snz-fr') ? s.tax.nextElementSibling : s.tax;
      after.parentNode.insertBefore(root, after.nextSibling);
    }
    return { root: root, box: s.box };
  }

  function render() {
    var m = mount();
    if (!m) return;
    if (variantPrice === null) variantPrice = readVariant(m.box);
    var setTotal = (variantPrice || 0) * readQty(m.box);
    var counted = cart + setTotal;
    var text = m.root.querySelector('[data-snz-pm-text]');
    var note = m.root.querySelector('[data-snz-pm-note]');
    var bar = m.root.querySelector('.snz-pm__bar');
    var fill = m.root.querySelector('.snz-pm__fill');
    var t, n = '', pct;
    /* 14 Oct 2026: UK delivery is free on every order (Royal Mail Tracked), so no threshold and no bar. */
    t = '<strong>Free Royal Mail delivery</strong>';
    pct = 100;
    bar.hidden = true;
    if (pct >= 100) m.root.setAttribute('data-free', ''); else m.root.removeAttribute('data-free');
    if (text.innerHTML !== t) text.innerHTML = t;
    if (note.textContent !== n) note.textContent = n;
    fill.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', (Math.min(counted, FREE) / 100).toFixed(2));
  }

  function refreshCart() {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c && typeof c.total_price === 'number') cart = c.total_price; render(); })
      .catch(render);
  }

  function boot() {
    try { render(); } catch (e) { return; }
    refreshCart(); /* the server-rendered bag total can be stale on a cached page */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches && e.target.matches('input.quantity__input[name="quantity"]')) render();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-input .quantity__button')) setTimeout(render, 0);
    });
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
          var v = evt && evt.data && evt.data.variant;
          variantPrice = v && typeof v.price === 'number' ? v.price : null;
          setTimeout(render, 0);
        });
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refreshCart(); });
      } catch (e) {}
    }
    /* back/forward cache restores a stale bag total */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
  }

  var st = document.createElement('style');
  st.textContent = CSS;
  (document.head || document.documentElement).appendChild(st);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
